import { ResumeContent } from '../../api/resumes';
import UnifiedArtifactCompiler from '../shared/UnifiedArtifactCompiler';

interface ResumeCompilerProps {
  contentItems: ResumeContent[];
  onResumeCreated?: () => void;
}

export default function ResumeCompiler({ contentItems, onResumeCreated }: ResumeCompilerProps) {
  return (
    <UnifiedArtifactCompiler
      contentItems={contentItems}
      onArtifactCreated={onResumeCreated || (() => {})}
      artifactType="resume"
      hideJobSelection={false}
    />
  );
}
